export class NoFiltersSelectedRule {
    forSearch(dependencies) {
        const { filterState, seoInfoBase } = dependencies;
        const selectionCount = seoInfoBase.getSelectionTypeCount(filterState);
        return Promise.resolve(selectionCount === 0);
    }
    forSitemapGenerator(filterKeyValues) {
        const filterKeys = Array.from(filterKeyValues.keys());
        return Promise.resolve(filterKeys.length === 0);
    }
    getName() {
        return 'NoFiltersSelectedRule';
    }
}
